export default __webpack_public_path__ + "static/media/dane-wetton.86aa985d.jpg";